// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// inital values
const filterInitialValue = { page: 0, pageSize: 10 }

const learnersFilterInitialValue = {
  ...filterInitialValue,
  query: '',
  status: ''
}

export const courseSlice = createSlice({
  name: 'courses',
  initialState: {
    selectedCourse: {},
    selectedTopic: {},
    selectedPage: {},
    coursesTableFilters: { ...filterInitialValue },
    topicsTableFilters: { ...filterInitialValue },
    learnersTableFilters: { ...learnersFilterInitialValue },
    pagesTableFilters: { ...filterInitialValue }
  },
  reducers: {
    setSelectedCourse(state, action) {
      state.selectedCourse[action.payload.key] = action.payload.value
    },
    setSelectedTopic(state, action) {
      state.selectedTopic[action.payload.key] = action.payload.value
    },
    setSelectedPage(state, action) {
      state.selectedPage[action.payload.key] = action.payload.value
    },
    setTopicsTableFilters(state, action) {
      state.topicsTableFilters = action.payload
    },
    setCourseTableFilters(state, action) {
      state.coursesTableFilters = action.payload
    },
    setPagesTableFilter(state, action) {
      state.pagesTableFilters = action.payload
    },
    setLearnersTableFilters(state, action) {
      state.learnersTableFilters = action.payload
    }
  }
})

export const {
  setSelectedCourse,
  setSelectedTopic,
  setSelectedPage,
  setCourseTableFilters,
  setTopicsTableFilters,
  setLearnersTableFilters,
  setPagesTableFilter
} = courseSlice.actions

export default courseSlice.reducer
